// import cn from 'classnames';
import { useCallback, useState, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
// import { useQuery } from "react-query";
// import { useQueryClient } from 'react-query';
// import i18n from "i18next";
import { Filters, FilterTypes } from '@containers/FiltersNew';
import { FilterModel } from '@hooks/useFiltersSearchParams';
import { Button, ButtonSize } from "@components/new/Button";
import { LinkButton, LinkButtonSize } from "@components/new/LinkButton";
// import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import DataGrid from '@containers/DataGridNew';
// import Photo from "@components/new/Photo";
// import { TableCellLink, TableColumn, TableRowType } from "@components/new/Table";
// import { Marketplace } from "@components/new/Marketplace";
// import { NoData } from "@components/new/NoData";
import MatchingItem from "../components/MatchingItem";
import MatchingModal from "../modals/MatchingModal";
import {
  getFBPMatchings,
  useFBPMatchingCounter,
  TRequestParams,
  TFBPMatchingItem,
} from "@api/apiClient/fbp";
import { useKnowledgeBase } from '@contexts/KnowledgeBaseContext';
import InfoIcon from '@assets/icons/outline/info.svg?react';
import IconPlus from '@assets/icons/outline/plus.svg?react';
// import IconLink from '@assets/icons/outline/git-compare.svg?react';
// import DelIcon from '@assets/icons/outline/trash-2.svg?react';
import styles from './Tab.module.scss';

const MatchingTab = ({ sellerWarehouseId, hasAliStores, hasWbStores, hasYmStores }: {
  sellerWarehouseId: string;
  hasAliStores: boolean;
  hasWbStores: boolean;
  hasYmStores: boolean;
}): ReactElement => {
  const { t } = useTranslation();
  // const queryClient = useQueryClient();
  // const [sorting, setSorting] = useState<{ column: string, direction: string } | undefined>(undefined);
  // const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [innerFilters, setInnerFilters] = useState<FilterModel[]>([]);
  const [matchingData, setMatchingData] = useState<TFBPMatchingItem | undefined>();

  const [isOpenMatchingModal, setIsOpenMatchingModal] = useState<boolean>(false);
  const { data: matchingCounter } = useFBPMatchingCounter(sellerWarehouseId ?? "");
  const { setKnowledgeBaseParams } = useKnowledgeBase();

  const openMatchingModal = () => {
    setIsOpenMatchingModal(true);
    setMatchingData(undefined);
  };

  const matchingsGetter = useCallback(
    ({ filters, sorting, page }: TRequestParams) => getFBPMatchings({ filters, sorting, page, sellerWarehouseId }),
    [sellerWarehouseId]
  );

  return (
    <div className={styles.tabContent}>
      <div className={styles.actionsRow}>
        <Filters
          id="fbp-matching"
          // openFilters={() => setIsFilterOpen(true)}
          items={[
            {
              name: 'skus',
              type: FilterTypes.MULTI_SEARCH_NEW,
              placeholder: t('fbpPage.itemSearch'),
            },
          ]}
          onChange={(v) => {
            setInnerFilters(v);
          }}
          values={innerFilters}
          // asPanel
        />

        <div className={styles.actionsRight}>
          <LinkButton
            icon={InfoIcon}
            size={LinkButtonSize.L}
            title={t('fbpPage.instructions')}
            onClick={() => setKnowledgeBaseParams(`https://unitrade-global.com/page139704916.html`)}
          />
          <Button
            size={ButtonSize.M}
            onClick={openMatchingModal}
            title={t('fbpPage.matchings.addMatchingBtn')}
            icon={IconPlus}
          />
        </div>
      </div>

      <DataGrid<TFBPMatchingItem, { onEdit: (v: TFBPMatchingItem) => void }>
        key={sellerWarehouseId}
        className={styles.matchingGrid}
        ItemComponent={MatchingItem}
        // defaultPageSize={10}
        filters={innerFilters}
        queryKey={["getFBPMatchings", sellerWarehouseId]}
        getData={matchingsGetter}
        viewProps={{
          onEdit: (v: TFBPMatchingItem) => {
            setIsOpenMatchingModal(true);
            setMatchingData(v);
          },
        }}
        noLoaderOnRefresh
        noDataProps={matchingCounter ? undefined : {
          title: t("fbpPage.matchings.noMatchingsTitle"),
          btnTitle: t('fbpPage.matchings.addMatchingBtn'),
          onClick: openMatchingModal,
          width: "max-content",
        }}
        pending={!sellerWarehouseId}
      />

      {isOpenMatchingModal && (
        <MatchingModal
          key={matchingData?.id}
          sellerWarehouseId={sellerWarehouseId}
          hasAliStores={hasAliStores}
          hasWbStores={hasWbStores}
          hasYmStores={hasYmStores}
          onClose={() => setIsOpenMatchingModal(false)}
          matchingData={matchingData}
        />
      )}
    </div>
  );
};

export default MatchingTab;
